import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Input } from '../components/ui/input';
import { Lock } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--admin-bg)' }}>
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-12">
          <img src="/AC_logo_longblack.png" alt="ALL CAPS" className="h-10" />
        </div>
        <div className="admin-card">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={18} />
            <h2 className="text-lg font-bold" style={{ fontFamily: 'var(--font-heading)' }}>ADMIN LOGIN</h2>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider font-semibold mb-1 block" style={{ fontFamily: 'var(--font-heading)' }}>E-MAIL</label>
              <Input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="admin-input"
                required
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider font-semibold mb-1 block" style={{ fontFamily: 'var(--font-heading)' }}>PASSWORT</label>
              <Input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="admin-input"
                required
              />
            </div>
            {error && <p data-testid="login-error" className="text-sm" style={{ color: 'var(--admin-danger)' }}>{error}</p>}
            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="admin-btn-primary w-full mt-2"
            >
              {loading ? 'LADEN...' : 'ANMELDEN'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
